import type { BaseTableParams } from "@dashboardApi/apis/types";
import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

import sharedConstants from "@lib/shared_constants.json";

export interface AppsApiLimitsCompanyRateLimitDatatableParams extends BaseTableParams {
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
}

const LIMIT_TYPES = sharedConstants.API_LIMITS.TYPE;
// Type is union of LIMIT_TYPES values
export type RateLimitType = (typeof LIMIT_TYPES)[keyof typeof LIMIT_TYPES];

export interface AppsApiLimitsCompanyRateLimitDatatableResultItem extends BaseTableResultItem {
  id: string;
  endpoints: string[];
  rate_limit: {
    limit: number;
    period: number;
  };
  type: RateLimitType;
  last_changed_timestamp: string;
}

export type AppsApiLimitsCompanyRateLimitDatatableResult =
  TableResult<AppsApiLimitsCompanyRateLimitDatatableResultItem>;
